import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-utils"
export default class extends Controller {
  blockNonNumeric(event) {
    const allowed = [
      "Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"
    ]

    if (allowed.includes(event.key)) return
    if ((event.ctrlKey || event.metaKey) && ["a", "c", "v", "x"].includes(event.key)) return
    if (!/^\d$/.test(event.key)) event.preventDefault()
  }
}
